import { DEFAULT_PROVIDER, MAX_LOG, type ProviderSettings, type ProviderStore, type UsageEntry } from "./types";

const KEY = "tasduvar:provider";

/** Eksik alanları varsayılanla tamamlar (eski sürüm ayarları). */
export function normalizeSettings(raw: unknown): ProviderSettings {
  const r = (raw && typeof raw === "object" ? raw : {}) as Partial<ProviderSettings>;
  return {
    version: 1,
    passwordHash: typeof r.passwordHash === "string" && r.passwordHash ? r.passwordHash : DEFAULT_PROVIDER.passwordHash,
    imagePdf: !!r.imagePdf,
    branding: { ...DEFAULT_PROVIDER.branding, ...(r.branding ?? {}) },
    defaults: r.defaults ?? {},
    features: { ...DEFAULT_PROVIDER.features, ...(r.features ?? {}) },
    usageLog: Array.isArray(r.usageLog) ? r.usageLog.slice(-MAX_LOG) : [],
    ...(r.billing ? { billing: r.billing } : {}),
    ...(r.seller ? { seller: r.seller } : {}),
  };
}

export class LocalStorageProviderStore implements ProviderStore {
  async get(): Promise<ProviderSettings> {
    try { const raw = window.localStorage.getItem(KEY); return raw ? normalizeSettings(JSON.parse(raw)) : structuredClone(DEFAULT_PROVIDER); } catch { return structuredClone(DEFAULT_PROVIDER); }
  }
  async set(s: ProviderSettings): Promise<void> { window.localStorage.setItem(KEY, JSON.stringify(normalizeSettings(s))); }
  async appendLog(e: UsageEntry): Promise<void> { const s = await this.get(); s.usageLog = [...s.usageLog, e].slice(-MAX_LOG); await this.set(s); }
}
